var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat20DpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chat_20dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "0103\\u66F4\\u65B0-live\\u5361\\u7247\\u53CA\\u53F3\\u4FA7\\u5C55\\u5F00\\u76F8\\u5173\\u6837\\u5F0F\\u66F4\\u65B0",
    transform: "translate(-446.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-28",
    transform: "translate(416.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat_20dp",
    transform: "translate(30.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,5 L15.8333333,5 L15.8333333,12.5 L5,12.5 L5,14.1666667 C5,14.625 5.375,15 5.83333333,15 L15,15 L18.3333333,18.3333333 L18.3333333,5.83333333 C18.3333333,5.375 17.9583333,5 17.5,5 Z M14.1666667,10 L14.1666667,2.5 C14.1666667,2.04166667 13.7916667,1.66666667 13.3333333,1.66666667 L2.5,1.66666667 C2.04166667,1.66666667 1.66666667,2.04166667 1.66666667,2.5 L1.66666667,14.1666667 L5,10.8333333 L13.3333333,10.8333333 C13.7916667,10.8333333 14.1666667,10.4583333 14.1666667,10 Z",
    id: "\\u5F62\\u72B6",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat20DpLight);
export default __webpack_public_path__ + "static/media/chat_20dp_light.a6ba2620f87f60525992100a06b02115.svg";
export { ForwardRef as ReactComponent };